export default "__VITE_ASSET__c4fe387d__"